import { API, graphqlOperation, Logger } from 'aws-amplify';
import { createInterview, updateInterview } from '@/graphql/mutations';
import { DuplicateError } from '@/errors/DuplicateError';
import { getInterview, interviewsById, interviewsByTreatmentSerialNumber } from '@/graphql/queries';
import { format } from 'date-fns'

const logger = new Logger('advanceInterview');

const advanceInterview = {
  namespaced: true,
  state: {
    name: '',
    kana: '',
    age: '',
    otherAge: '',
    nameOfParent: '',
    telOfParent: '',
    certificates: [],
    inspectionDate: format(Date.now(), 'yyyy-MM-dd'),
    searchMethod: '',
    searchOtherMethod: '',
    vaccinationHistory: '',
    riskOfSerious: [],
    riskOfSeriousOther: '',
    obesityRisk: '',
    pregnancyRisk: '',
    smokingRisk: '',
    otherRisk: '',
    kitName: '',
    coronaVaccinationDate: format(Date.now(), 'yyyy-MM-dd'),
    coronaVaccineName: '',
    fluVaccinationHistory: '',
    symptoms: '',
    dateOfOnset: format(Date.now(), 'yyyy-MM-dd'),
    fever: '',
    feverNum: '',
    cough: '',
    otherThanCough: '',
    senseOfFatigue: '',
    headache: '',
    nausea: '',
    diarrhea: '',
    conjunctivitis: '',
    pharyngitis: '',
    travelHistory: '',
    departureDate: '',
    entryDate: '',
    destination: '',
    coronaPatientContact: '',
    fulPatientContact: '',
    hasIntensiveContact: '',
    causeIntensiveContact: [],
    causeIntensiveContactOther: '',
    placeIntensiveContact: [],
    placeIntensiveContactOther: '',
    hasDuringTreatment: '',
    id: ''
  },
  getters: {
    name: state => state.name,
    kana: state => state.kana,
    age: state => state.otherAge,
    otherAge: state => state.ageOther,
    nameOfParent: state => state.nameOfParent,
    telOfParent: state => state.telOfParent,
    certificates: state => state.certificates,
    inspectionDate: state => state.inspectionDate,
    searchMethod: state => state.searchMethod,
    searchOtherMethod: state => state.searchOtherMethod,
    vaccinationHistory: state => state.vaccinationHistory,
    riskOfSerious: state => state.riskOfSerious,
    riskOfSeriousOther: state => state.riskOfSeriousOther,
    obesityRisk: state => state.obesityRisk,
    pregnancyRisk: state => state.pregnancyRisk,
    smokingRisk: state => state.smokingRisk,
    otherRisk: state => state.otherRisk,
    kitName: state => state.kitName,
    coronaVaccinationDate: state => state.coronaVaccinationDate,
    coronaVaccineName: state => state.coronaVaccineName,
    fluVaccinationHistory: state => state.fluVaccinationHistory,
    symptoms: state => state.symptoms,
    dateOfOnset: state => state.dateOfOnset,
    fever: state => state.fever,
    feverNum: state => state.feverNum,
    cough: state => state.cough,
    otherThanCough: state => state.otherThanCough,
    senseOfFatigue: state => state.senseOfFatigue,
    headache: state => state.headache,
    nausea: state => state.nausea,
    diarrhea: state => state.diarrhea,
    conjunctivitis: state => state.conjunctivitis,
    pharyngitis: state => state.pharyngitis,
    travelHistory: state => state.travelHistory,
    departureDate: state => state.departureDate,
    entryDate: state => state.entryDate,
    destination: state => state.destination,
    coronaPatientContact: state => state.coronaPatientContact,
    fulPatientContact: state => state.fulPatientContact,
    hasIntensiveContact: state => state.hasIntensiveContact,
    causeIntensiveContact: state => state.causeIntensiveContact,
    placeIntensiveContact: state => state.placeIntensiveContact,
    causeIntensiveContactOther: state => state.causeIntensiveContactOther,
    placeIntensiveContactOther: state => state.placeIntensiveContactOther,
    hasDuringTreatment: state => state.hasDuringTreatment,
    id: state => state.id
  },
  mutations: {
    setName: (state, payload) => state.name = payload,
    setKana: (state, payload) => state.kana = payload,
    setAge: (state, payload) => state.age = payload,
    setOtherAge: (state, payload) => state.otherAge = payload,
    setCertificates: (state, payload) => state.certificates = payload,
    setNameOfParent: (state, payload) => state.nameOfParent = payload,
    setTelOfParent: (state, payload) => state.telOfParent = payload,
    setInspectionDate: (state, payload) => state.inspectionDate = payload,
    setSearchMethod: (state, payload) => state.searchMethod = payload,
    setSearchOtherMethod: (state, payload) => state.searchOtherMethod = payload,
    setVaccinationHistory: (state, payload) => state.vaccinationHistory = payload,
    setRiskOfSerious: (state, payload) => state.riskOfSerious = payload,
    setRiskOfSeriousOther: (state, payload) => state.riskOfSeriousOther = payload,
    setObesityRisk: (state, payload) => state.obesityRisk = payload,
    setPregnancyRisk: (state, payload) => state.pregnancyRisk = payload,
    setSmokingRisk: (state, payload) => state.smokingRisk = payload,
    setOtherRisk: (state, payload) => state.otherRisk = payload,
    setKitName: (state, payload) => state.kitName = payload,
    setCoronaVaccinationDate: (state, payload) => state.coronaVaccinationDate = payload,
    setCoronaVaccineName: (state, payload) => state.coronaVaccineName = payload,
    setFluVaccinationHistory: (state, payload) => state.fluVaccinationHistory = payload,
    setSymptoms: (state, payload) => state.symptoms = payload,
    setDateOfOnset: (state, payload) => state.dateOfOnset = payload,
    setFever: (state, payload) => state.fever = payload,
    setFeverNum: (state, payload) => state.feverNum = payload,
    setCough: (state, payload) => state.cough = payload,
    setOtherThanCough: (state, payload) => state.otherThanCough = payload,
    setSenseOfFatigue: (state, payload) => state.senseOfFatigue = payload,
    setHeadache: (state, payload) => state.headache = payload,
    setNausea: (state, payload) => state.nausea = payload,
    setDiarrhea: (state, payload) => state.diarrhea = payload,
    setConjunctivitis: (state, payload) => state.conjunctivitis = payload,
    setPharyngitis: (state, payload) => state.pharyngitis = payload,
    setTravelHistory: (state, payload) => state.travelHistory = payload,
    setDepartureDate: (state, payload) => state.departureDate = payload,
    setEntryDate: (state, payload) => state.entryDate = payload,
    setDestination: (state, payload) => state.destination = payload,
    setCoronaPatientContact: (state, payload) => state.coronaPatientContact = payload,
    setFulPatientContact: (state, payload) => state.fulPatientContact = payload,
    setHasIntensiveContact: (state, payload) => state.hasIntensiveContact = payload,
    setCauseIntensiveContact: (state, payload) => state.causeIntensiveContact = payload,
    setPlaceIntensiveContact: (state, payload) => state.placeIntensiveContact = payload,
    setCauseIntensiveContactOther: (state, payload) => state.causeIntensiveContactOther = payload,
    setPlaceIntensiveContactOther: (state, payload) => state.placeIntensiveContactOther = payload,
    serHasDuringTreatment: (state, payload) => state.hasDuringTreatment = payload,
    setId: (state, payload) => state.id = payload,

    setUserInfo: (state, payload) => {
      if (payload === null) {
        return
      }
      state.name  = payload.name ?? ''
      state.age   = payload.age ?? ''
      state.kana  = payload.kana ?? ''
      state.otherAge = payload.otherAge ?? ''
      state.certificates = payload.certificates ?? ''
      state.nameOfParent = payload.nameOfParent ?? ''
      state.telOfParent  = payload.telOfParent ?? ''
    },
    setRiskDate: (state, payload) => {
      if (payload === null) {
        return
      }
      state.hasDuringTreatment = payload.hasDuringTreatment ?? ''
      state.obesityRisk        = payload.obesityRisk ?? ''
      state.otherRisk          = payload.otherRisk ?? ''
      state.pregnancyRisk      = payload.pregnancyRisk ?? ''
      state.riskOfSerious      = payload.riskOfSerious ?? ''
      state.riskOfSeriousOther = payload.riskOfSeriousOther ?? ''
      state.smokingRisk        = payload.smokingRisk ?? ''
    },
    setIntensiveContact: (state, payload) => {
      if (payload === null) {
        return
      }
      state.coronaPatientContact = payload.coronaPatientContact ?? ''
      state.fulPatientContact    = payload.fulPatientContact ?? ''
      state.hasIntensiveContact  = payload.hasIntensiveContact ?? ''
      state.causeIntensiveContact = payload.causeIntensiveContact ?? ''
      state.causeIntensiveContactOther = payload.causeIntensiveContactOther ?? ''
      state.placeIntensiveContact = payload.placeIntensiveContact ?? ''
      state.placeIntensiveContactOther = payload.placeIntensiveContactOther ?? ''
    },
    setInterview: (state, payload) => {
      if (payload === null) {
        return
      }
      state.conjunctivitis = payload.conjunctivitis ?? ''
      state.coronaVaccinationDate = payload.coronaVaccinationDate ?? ''
      state.coronaVaccineName     = payload.coronaVaccineName ?? ''
      state.cough                 = payload.cough ?? ''
      state.dateOfOnset           = payload.dateOfOnset ?? ''
      state.diarrhea              = payload.diarrhea ?? ''
      state.fever                 = payload.fever ?? ''
      state.feverNum              = payload.feverNum ?? ''
      state.fluVaccinationHistory = payload.fluVaccinationHistory ?? ''
      state.headache              = payload.headache ?? ''
      state.inspectionDate        = payload.inspectionDate ?? ''
      state.kitName               = payload.kitName ?? ''
      state.nausea                = payload.nausea ?? ''
      state.otherThanCough        = payload.otherThanCough ?? ''
      state.pharyngitis           = payload.pharyngitis ?? ''
      state.searchMethod          = payload.searchMethod ?? ''
      state.searchOtherMethod     = payload.searchOtherMethod ?? ''
      state.senseOfFatigue        = payload.senseOfFatigue ?? ''
      state.symptoms              = payload.symptoms ?? ''
      state.vaccinationHistory    = payload.vaccinationHistory ?? ''
    },
    setTravelHistoryDate: (state, payload) => {
      if (payload === null) {
        return
      }
      state.departureDate = payload.departureDate
      state.destination   = payload.destination
      state.entryDate     = payload.entryDate
      state.travelHistory = payload.travelHistory
    }
  },
  actions: {
    setName: ({ commit }, value) => commit('setName', value),
    setKana: ({ commit }, value) => commit('setKana', value),
    setAge: ({ commit }, value) => commit('setAge', value),
    setOtherAge: ({ commit }, value) => commit('setOtherAge', value),
    setCertificates: ({ commit }, value) => commit('setCertificates', value),
    setNameOfParent: ({ commit }, value) => commit('setNameOfParent', value),
    setTelOfParent: ({ commit }, value) => commit('setTelOfParent', value),
    setInspectionDate: ({ commit }, value) => commit('setInspectionDate', value),
    setSearchMethod: ({ commit }, value) => commit('setSearchMethod', value),
    setSearchOtherMethod: ({ commit }, value) => commit('setSearchOtherMethod', value),
    setVaccinationHistory: ({ commit }, value) => commit('setVaccinationHistory', value),
    setRiskOfSerious: ({ commit }, value) => commit('setRiskOfSerious', value),
    setRiskOfSeriousOther: ({ commit }, value) => commit('setRiskOfSeriousOther', value),
    setObesityRisk: ({ commit }, value) => commit('setObesityRisk', value),
    setPregnancyRisk: ({ commit }, value) => commit('setPregnancyRisk', value),
    setSmokingRisk: ({ commit }, value) => commit('setSmokingRisk', value),
    setOtherRisk: ({ commit }, value) => commit('setOtherRisk', value),
    setKitName: ({ commit }, value) => commit('setKitName', value),
    setCoronaVaccinationDate: ({ commit }, value) => commit('setCoronaVaccinationDate', value),
    setCoronaVaccineName: ({ commit }, value) => commit('setCoronaVaccineName', value),
    setFluVaccinationHistory: ({ commit }, value) => commit('setFluVaccinationHistory', value),
    setSymptoms: ({ commit }, value) => commit('setSymptoms', value),
    setDateOfOnset: ({ commit }, value) => commit('setDateOfOnset', value),
    setFever: ({ commit }, value) => commit('setFever', value),
    setFeverNum: ({ commit }, value) => commit('setFeverNum', value),
    setCough: ({ commit }, value) => commit('setCough', value),
    setOtherThanCough: ({ commit }, value) => commit('setOtherThanCough', value),
    setSenseOfFatigue: ({ commit }, value) => commit('setSenseOfFatigue', value),
    setHeadache: ({ commit }, value) => commit('setHeadache', value),
    setNausea: ({ commit }, value) => commit('setNausea', value),
    setDiarrhea: ({ commit }, value) => commit('setDiarrhea', value),
    setConjunctivitis: ({ commit }, value) => commit('setConjunctivitis', value),
    setPharyngitis: ({ commit }, value) => commit('setPharyngitis', value),
    setTravelHistory: ({ commit }, value) => commit('setTravelHistory', value),
    setDepartureDate: ({ commit }, value) => commit('setDepartureDate', value),
    setEntryDate: ({ commit }, value) => commit('setEntryDate', value),
    setDestination: ({ commit }, value) => commit('setDestination', value),
    setCoronaPatientContact: ({ commit }, value) => commit('setCoronaPatientContact', value),
    setFulPatientContact: ({ commit }, value) => commit('setFulPatientContact', value),
    setHasIntensiveContact: ({ commit }, value) => commit('setHasIntensiveContact', value),
    setCauseIntensiveContact: ({ commit }, value) => commit('setCauseIntensiveContact', value),
    setPlaceIntensiveContact: ({ commit }, value) => commit('setPlaceIntensiveContact', value),
    setCauseIntensiveContactOther: ({ commit }, value) => commit('setCauseIntensiveContactOther', value),
    setPlaceIntensiveContactOther: ({ commit }, value) => commit('setPlaceIntensiveContactOther', value),
    serHasDuringTreatment: ({ commit }, value) => commit('serHasDuringTreatment', value),

    /**
     * 事前問診の取得(事前問診IDをキーにして)
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    getInterviewById: async ({ commit }, payload) => {
      logger.info('getInterviewById', payload);
      const authorizationToken = payload.jwtToken;
      try {
        const response = await allowDeniedFieldsException(API.graphql(graphqlOperation(interviewsById, {
          id: payload.id,
          limit: 1,
        }, authorizationToken)));

        logger.info('interviewsById.response', response);

        if (Array.from(response.data.interviewsById.items).length === 0) {
          return response;
        }
        const data = response.data.interviewsById.items[0];
        commitInterview(commit,  data);
        return response;
      } catch (e) {
        logger.error('interviewsById.exception', e);
        throw e;
      }
    },
    getInterviewsByTreatmentSerialNumber: async (context, payload) => {
      logger.info('getInterviewsByTreatmentSerialNumber', payload);
      try {
        const response = await API.graphql({
          query: interviewsByTreatmentSerialNumber,
          authMode: 'AWS_IAM',
          variables: {
            treatmentSerialNumber: payload.id,
            limit: 1
          }
        });

        logger.info('getInterviewsByTreatmentSerialNumber.response', response);
        return response.data.interviewsByTreatmentSerialNumber;
      } catch (e) {
        logger.error('getInterview.exception', e);
        throw e;
      }
    },
    /**
     * 事前問診の取得(treatmentConsultationSeqをキーにして)
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    getInterview: async ({ commit }, payload) => {
      logger.info('getInterview', payload);
      const authorizationToken = payload.jwtToken;
      try {
        const response = await allowDeniedFieldsException(API.graphql(graphqlOperation(getInterview, {
          treatmentConsultationSeq: payload.treatmentConsultationSeq,
        }, authorizationToken)));

        logger.info('getInterview.response', response);
        const data = response.data.getInterview;
        if (data === null) {
          return response
        }
        commitInterview(commit, data);
        return response;
      } catch (e) {
        logger.error('getInterview.exception', e);
        throw e;
      }
    },

    /**
     * 事前問診、全てのセクションを登録
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    createInterviewAllSection: async (context, payload) => {
      logger.info('createMedicalRecordAllSection', payload);
      const authorizationToken = payload.jwtToken;
      const input = {
        treatmentConsultationSeq: payload.treatmentConsultationSeq,
        treatmentSerialNumber: payload.treatmentSerialNumber,
        userInfo: payload.userInfo,
        riskOfSerious: payload.riskOfSerious,
        interview: payload.interview,
        travelHistory: payload.travelHistory,
        intensiveContact: payload.intensiveContact,
        statusCode: payload.statusCode,
      };
      try {
        const response = await allowDeniedFieldsException(API.graphql(graphqlOperation(createInterview, {
          input: input,
        }, authorizationToken)));
        logger.info('updateRecord.response', response);
        return response
      } catch (e) {
        logger.error('updateRecord.exception', e);
        throw e;
      }
    },

    /**
     * 事前問診、全てのセクションを更新リトライの場合は再実行
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    upsertInterviewAllSection: async (context, payload) => {
      logger.info('upsertInterviewAllSection', payload);
      const { jwtToken, treatmentConsultationSeq, treatmentSerialNumber, userInfo, riskOfSerious, interview, travelHistory, intensiveContact, statusCode, interviewError } = payload;
      const input = {
        treatmentConsultationSeq,
        treatmentSerialNumber,
        userInfo,
        riskOfSerious,
        interview,
        travelHistory,
        intensiveContact,
        statusCode
      };

      try {
        const record = await allowDeniedFieldsException(API.graphql(graphqlOperation(getInterview, {
          treatmentConsultationSeq: payload.treatmentConsultationSeq,
        }, jwtToken)));
        // レコードが存在するかつ前回のリクエストでエラーが発生していない場合二重リクエストでエラーとする
        if (record.data.getInterview !== null && interviewError === false) {
          throw new DuplicateError();
        }
        const mutationSchema = record.data.getInterview === null ? createInterview : updateInterview
        const response = await allowDeniedFieldsException(API.graphql(graphqlOperation(mutationSchema, {
          input: input,
        }, jwtToken)));
        logger.info('upsertRecord.response', response);

        if (mutationSchema === createInterview) {
          return response.data.createInterview.id;
        }
        return response.data.updateInterview.id;
      } catch (e) {
        logger.error('upsertRecord.exception', e);
        throw e;
      }
    },

    /**
     * 事前問診、インタビュー更新、登録処理
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    upsertMedicalRecordSection: async (context, payload) => {
      logger.info('upsertMedicalRecordSection', payload);
      const authorizationToken = payload.jwtToken;
      const input = {
        treatmentConsultationSeq: payload.treatmentConsultationSeq,
        treatmentSerialNumber: payload.treatmentSerialNumber,
        userInfo: payload.userInfo,
        recordTime: payload.recordTime,
        recordConsultation: payload.recordConsultation,
        recordAssessment: payload.recordAssessment,
        recordPlan: payload.recordPlan,
        statusCode: 1
      };
      try {
        if (payload.isRegistered) {
          const response = await API.graphql(graphqlOperation(updateInterview, {
            input: input,
          }, authorizationToken));
          logger.info('upsertMedicalRecordSection.response', response);
        } else {
          const response = await API.graphql(graphqlOperation(createInterview, {
            input: input,
          }, authorizationToken));
          logger.info('upsertMedicalRecordSection.response', response);
        }
      } catch (e) {
        logger.error('upsertMedicalRecordSection.exception', e);
        throw e;
      }
    },

    /**
     * 事前問診回答一連処理
     * @returns {Promise<void>}
     */
    processInterviewAnswer: async (context, payload) => {
      logger.info('processInterviewAnswer');
      const id = await context.dispatch('upsertInterviewAllSection', payload);
      await context.dispatch('answerInterviewApi', {
        token: payload.jwtToken,
        treatmentConsultationSeq: payload.treatmentConsultationSeq,
        interviewId: id,
        interviewError: payload.interviewError
      });
    },
    /**
     * 事前問診の回答API呼び出し
     * @returns {Promise<void>}
     */
    answerInterviewApi: async (context, payload) => {
      logger.info('answerInterviewApi');

      try {
        const {
          token,
          treatmentConsultationSeq,
          interviewId,
        } = payload;
        const response = await API.post('answerInterview', '/items', {
          headers: { 'Content-Type': 'application/json' },
          body: {
            accessToken: token,
            treatmentConsultationSeq: treatmentConsultationSeq,
            interviewId: interviewId,
          },
          responseType: 'json',
        });

        logger.info('answerInterviewApi.response', response);
      } catch (e) {
        logger.error('answerInterviewApi.exception', e);
        throw e;
      }
    },
  },
};

/**
 * Lambda AuthorizerのdeniedFieldsでのUnauthorized exceptionを正常系として扱う
 * @param apiPromise API呼び出しのPromise
 */
async function allowDeniedFieldsException(apiPromise) {
  logger.info('allowDeniedFieldsException', apiPromise);

  try {
    return await apiPromise;
  } catch (e) {
    logger.info('allowDeniedFieldsException', e);
    // そもそもdataがない
    if (!('data' in e)) {
      throw e;
    }

    // dataの中に有効なキーが存在する(ここは各query名がキーとなる)
    const existsValidKey = Object.keys(e.data).some(value => value !== null);
    // errorがすべてUnauthorized
    const isUnauthorized = e.errors.every(error => error.errorType === 'Unauthorized');
    // 一部制限があるエラーの場合は、そのままレスポンスを返す
    if (existsValidKey && isUnauthorized) {
      return e;
    }

    throw e;
  }
}

/**
 * 事前問診の情報をcommitする
 * @param commit
 * @param data
 */
function commitInterview(commit, data) {
  commit('apiParams/setTreatmentConsultationSeq', data.treatmentConsultationSeq, { root: true });
  commit('setId', data.id);
  commit('covidCertificate/setCovidCertificatePath',
    (data.covidCertificatePath !== null && data.covidCertificatePath !== undefined &&  data.covidCertificatePath !== '')
    ? data.covidCertificatePath : '',
    { root: true }
  )
  commit('setUserInfo', JSON.parse(data.userInfo));
  commit('setRiskDate', JSON.parse(data.riskOfSerious));
  commit('setIntensiveContact', JSON.parse(data.intensiveContact));
  commit('setInterview', JSON.parse(data.interview));
  commit('setTravelHistoryDate', JSON.parse(data.travelHistory));
}

export default advanceInterview;

